export const Celebrities = [
    {
        type: "Celebrities",
        name: "Joaquin Phoenix",
        category: "Actor, Activist",
        author: "",
        description: "",
        link: "https://www.azquotes.com/author/11632-Joaquin_Phoenix/tag/animal",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Peter Dinklage",
        category: "Actor; Game of Thrones",
        author: "",
        description: "",
        link: "https://veganuary.com/people/peter-dinklage/",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Ariana Grande",
        category: "Recording Artist and Actress",
        author: "",
        description: "",
        link: "https://veganuary.com/people/ariana-grande/",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Russell Brand",
        category: "Actor; Comedian; Host",
        author: "",
        description: "",
        link: "https://veganuary.com/people/russell-brand-2/",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Woody Harrelson",
        category: "Actor; Hunger Games",
        author: "",
        description: "",
        link: "https://www.huffingtonpost.com/2013/12/01/vegan-celebrities_n_4351908.html?guccounter=1",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Kendrick Farris",
        category: "Olympic Weightlifter",
        author: "",
        description: "",
        link: "https://www.huffingtonpost.ca/entry/kendrick-farris-olympics-vegan_n_57ab6be7e4b0db3be07ccc07",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Bill Clinton",
        category: "Former President",
        author: "",
        description: "",
        link: "https://www.huffingtonpost.com/2013/12/01/vegan-celebrities_n_4351908.html?guccounter=1",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Billie Eilish",
        category: "Singer Songwriter",
        author: "",
        description: "",
        link: "https://www.livekindly.co/billie-eilish-condemns-meat-dairy-industry/",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Evanna Lynch",
        category: "Actress",
        author: "",
        description: "",
        link: "https://veganuary.com/people/evanna-lynch/",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Brad Pitt",
        category: "Actor and Producer",
        author: "",
        description: "",
        link: "https://www.huffingtonpost.com/2013/12/01/vegan-celebrities_n_4351908.html?guccounter=1",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Elliot Page",
        category: "Actor and Producer",
        author: "",
        description: "",
        link: "https://www.bustle.com/articles/149515-32-verified-currently-vegan-celebrities",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Casey Affleck",
        category: "Actor and Producer",
        author: "",
        description: "",
        link: "https://www.bustle.com/articles/149515-32-verified-currently-vegan-celebrities",
        "": "",
    },
    {
        type: "Celebrities",
        name: "James Cameron",
        category: "Writer / Director / Producer",
        author: "",
        description: "",
        link: "https://www.mensjournal.com/health-fitness/james-cameron-why-i-eat-a-vegan-diet-20150915",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Lewis Hamilton",
        category: "F1 Driver",
        author: "",
        description: "",
        link: "https://www.plantbasednews.org/post/vegan-lewis-hamilton-meat-industry-animal-torture-9-million-followers",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Jon Stewart",
        category:
            "Comedian / Writer / Producer / Director / Political commentator / Actor  and Television host. Runs a farm sanctuary.",
        author: "",
        description: "",
        link: "https://www.livekindly.co/jon-stewart-vegan-because-pigs-with-personality/",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Pamela Anderson",
        category: "Actress / Model / Television personality / Activist.",
        author: "",
        description: "",
        link: "http://www.healthylivingmagazine.us/Articles/559/",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Stevie Wonder",
        category: "Singer / Songwriter / Musician and Record Producer.",
        author: "",
        description: "",
        link: "https://mercyforanimals.org/stevie-wonder-talks-veganism-and-climate",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Maggie Q",
        category: "Actress / Model and Animal Rights Activist",
        author: "",
        description: "",
        link: "https://vegnews.com/2017/9/why-action-star-maggie-q-is-a-real-life-vegan-heroine",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Yuval Noah Harari",
        category: "Historian / Author and Professor",
        author: "",
        description: "",
        link: "https://en.wikipedia.org/wiki/Yuval_Noah_Harari",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Alissa White-Gluz",
        category: "Singer",
        author: "",
        description: "",
        link: "https://en.wikipedia.org/wiki/Alissa_White-Gluz",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Davey Havok",
        category: "Singer / Actor / Fashion designer and Author",
        author: "",
        description: "",
        link: "https://youtu.be/7YkfNWGHu7c",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Jane Goodall",
        category: "PhD and Activist",
        author: "",
        description: "",
        link: "https://www.janegoodall.org/",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Moby",
        category: "Musician",
        author: "",
        description: "",
        link: "https://www.livekindly.co/who-is-moby-vegan/",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Nathalie Emmanual",
        category: "Actress",
        author: "",
        description: "",
        link: "https://www.onegreenplanet.org/vegan-food/game-of-thrones-nathalie-emmanuel/",
        "": "",
    },
    {
        type: "Celebrities",
        name: "Tobey Maguire",
        category: "Actor",
        author: "",
        description: "",
        link: "https://viva.org.uk/lifestyle/living-vegan/celebrities/actors-directors/tobey-maguire/",
        "": "",
    },
]
